import { render, staticRenderFns } from "./chooseBase.vue?vue&type=template&id=2d0b7703&scoped=true"
import script from "./chooseBase.vue?vue&type=script&lang=js"
export * from "./chooseBase.vue?vue&type=script&lang=js"
import style0 from "./chooseBase.vue?vue&type=style&index=0&id=2d0b7703&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0b7703",
  null
  
)

export default component.exports